<template>
    <!-- 升学途径 (艺术类招生)-->
    <div class="artEnrollment">
        <div class="banner">
            <img src="/imgs/wayToStudy/main/banner_tool.png" alt="">
        </div>
        <div class="main">
            <h6 class="main_title">艺术类专业介绍</h6>
            <div class="main_box">
                <p>艺术类专业是指普通高等艺术类院校招生的专业或普通高等学校的艺术类专业，例如：音乐、美术、表演、舞蹈、编导、播音主持等专业。艺术类专业招生是为高等艺术教育选拔具有较高艺术素质和艺术领悟力的专业人才。</p>
            </div>    
        </div>
        <div class="benefit main">
            <h6 class="main_title">招生专业</h6>
            <div class="main_box">
                <p>艺术类专业包括《普通高等学校本科专业目录(2012年)》中“艺术学门类”下设各专业（见下表），以及《普通高等学校高等职业教育(专科)专业目录(2015年)》中“艺术设计类”“表演艺术类”下设各专业和“民族文化类”“广播影视类”等部分专业。</p>
            </div>
            <table>
                <tr v-for="(item, index) in major" :key="index">
                    <td>
                        <img :src="item.img_url" alt="">
                        <p>{{item.title}}</p>
                    </td>
                    <td>{{item.detail}}</td>
                </tr>
                
            </table>
        </div>
        <div class="application_process main">
            <h6 class="main_title">招考流程</h6>
            <ul class="lis_box">
                <li v-for="(item, index) in zhaokaoliucheng" :key="index">
                    <p class="title">{{item.time}}</p>
                    <p class="detail">{{item.detail}}</p>
                </li>
            </ul>
        </div>
        <div class="main">
            <h6 class="main_title">考试与招生</h6>
            <div class="main_box">
               <p>
                   报考艺术类专业的考生，除了参加普通高考文化课考试之外，还要参加专业考试。获得专业考试(省统考或校考)合格证的考生才有资格填报相关艺术院校(专业)志愿。此外，艺术类专业录取时，执行艺术类专业批次控制分数线，其录取原则也与普通专业有所不同。
               </p>
            </div>   
        </div>
        <!-- 录取要求 -->
        <div class="liuquyaoqiu main">
            <h6 class="main_title">录取要求</h6>
            <div class="main_box">
                <p v-for="(item, index) in liuquyaoqiu" :key="index">{{item.detail}}</p>
            </div>   
        </div>
        <div class="remind main">
            <h6 class="main_title">特别提醒</h6>
            <div class="main_box">
                <p><span>1</span>凡艺术类专业录取的学生，入学后不得转入非艺术类专业</p>
                <p><span>2</span>色盲的考生不能报考美术学、绘画、艺术设计、摄影、动画等专业。此外，听力不合格的考生不宜就读音乐学、录音艺术等专业;嗅觉迟钝、口吃、步态异常、驼背，面部疤痕、血管瘤、黑色素痣、白癜风的考生，不宜就读音乐表演、表演等专业。</p>
                <p><span>3</span>招生院校可能会对某些专业提出更多的要求，例如身高等。考生在报考时，要认真阅读当年的招生简章或者咨询高校。</p>
                <p><span>4</span>考生所报考专业在省统考范围内的，必须参加省统考。全国所有省级招办都会组织美术学类和设计学类专业省统考，有的省(区、市)还会组织音乐类、舞蹈类等专业统考。详情请关注本省招办当年的艺术类专业招生工作通知。省统考未涉及的专业，考生参加校考即可。</p>
                <p><span>5</span>报考艺术类专业的考生，可以兼报除提前录取批次外的其他批次的非艺术类专业。(如生源所在省级招办另有规定，则以省级招办当年规定为准。</p>
            </div>   
        </div>
        <div class="universities main">
            <h6 class="main_title">
                招生院校一览 
                <span>*由于试点高校陆续更新，请各位考生以考试院/高校公布的消息为准</span>
            </h6>
            <div class="school_box">
                <p class="school_title">独立设置的本科艺术院校（30所）</p>
                <ul>
                    <li  v-for="(item, index) in artUniversity30" :key="index" @click="goUniversity1(item,index)" :class="index==11||16||20">{{item}}</li>
                </ul>
            </div>   
            <div class="school_box">
                <p class="school_title">只在本省实行自主选拔录取院校</p>
                <ul class="shengnei">
                    <li  v-for="(item, index) in artUniversity15" :key="index" @click="goUniversity(item)">{{item}}</li>
                </ul>
            </div>
            <div class="other_school" v-for="(item, index) in otherArtUniversity" :key="index">
                <p class="province_school">{{item.title}}</p>
                <ul class="shengnei">
                    <li  v-for="(school, index) in item.schoolName" :key="index" @click="goUniversity(school)">{{school}}</li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    // components: { Yuanxiaoku },
    // props: [ 'message' ],
     data() {
        return {
            major: [
                { title: '艺术学理论类', detail: '艺术史论', img_url: '/imgs/wayToStudy/common/icon_yishulilun.png' },
                { title: '音乐与舞蹈学类', detail: '音乐表演、音乐学、作曲与作曲技术理论、舞蹈表演、舞蹈学、舞蹈编导', img_url: '/imgs/wayToStudy/common/icon_wudao.png' },
                { title: '戏剧与影视学类   ', detail: '表演、戏剧学、电影学、戏剧影视文学、广播电视编导、戏剧影视导演、戏剧影视美术设计、录音艺术、播音与主持艺术、动画、影视摄影与制作（T）', img_url: '/imgs/wayToStudy/common/icon_yingshi.png' },
                { title: '美术学类', detail: '美术学、绘画、雕塑、摄影、书法学（T）、中国画（T）', img_url: '/imgs/wayToStudy/common/icon_meishu.png' },
                { title: '设计学类', detail: '艺术设计学、视觉传达设计、环境设计、产品设计、服装与服饰设计、公共艺术、工艺美术、数字媒体艺术、艺术与科技（T）', img_url: '/imgs/wayToStudy/common/icon_yishu.png' },
            ],
            zhaokaoliucheng: [
                { time: '高考报名', detail: '参加各省统一考试' },
                { time: '专业考试', detail: '分为省统考跟校考两类' },
                { time: '高考', detail: '参加全国统一文化课考试' },
                { time: '填报志愿', detail: '根据合格证填报专业志愿' },
                { time: '录　　取', detail: '等待录取通知书发放' }
            ],
            // 录取要求
            liuquyaoqiu: [
                { detail: '（1）考生报考艺术类专业单独考试招生的高校，不得低于生源省份普通本科批次或普通本科第二批次录取控制分数线。' },
                { detail: '（2）艺术类专业录取工作安排在各省(区、市)相应普通本科、高职(专科)提前批次集中录取。' },
                { detail: '（3）艺术类本科专业高考文化课录取控制分数线不得低于本省(区、市)普通本科第二批次录取控制分数线的65%，适当提高艺术学理论类、戏剧与影视学类(不含表演)有关本科专业高考文化课录取控制分数线。' },
                { detail: '（4）艺术类高职(专科)专业录取控制分数线不得低于本省(区、市)普通高职(专科)录取控制分数线的70%。录取期间，各省(区、市)和高校不得为了完成招生计划而降低初次划定的最低录取控制分数线。' }
            ],
            // 独立设置的本科艺术院校（30所）
            artUniversity30:["中央音乐学院", "中国音乐学院", "北京电影学院", "西安美术学院", "北京舞蹈学院", "中国戏曲学院", "天津音乐学院", "天津美术学院", "鲁迅美术学院", "西安音乐学院", "云南艺术学院", "吉林艺术学院上海音乐学院", "上海戏剧学院", "南京艺术学院", "新疆艺术学院", "中国美术学院", "景德镇陶瓷学院", "山东艺术学院", "山东工艺美术学院", "湖北美术学院", "解放军艺术学院", "武汉音乐学院", "广州美术学院", "星海音乐学院", "广西艺术学院", "四川美术学院", "四川音乐学院"],
            // 参照独立设置本科艺术院校招生高校名单（15所）
            artUniversity15: ["清华大学", "中国传媒大学", "中央民族大学", "东华大学", "北京服装学院", "武汉设计工程学院", "江南大学", "天津工业大学", "上海视觉艺术学院", "北京印刷学院", "苏州大学", "浙江音乐学院", "浙江传媒学院", "浙江理工大学", "内蒙古大学"],
            // 其他有艺术类专业招生的院校
            otherArtUniversity: [
                { title: '安徽艺术生招生院校（本科）', schoolName: ["安徽工业大学", "安徽农业大学", "安徽外国语学院", "安徽农业大学经济技术学院", "合肥工业大学", "安徽工业大学工商学院", "阜阳师范学院信息工程学院", "安徽财经大学", "安徽大学江淮学院", "安徽理工大学", "安徽建筑大学", "合肥学院", "滁州学院", "蚌埠学院", "安徽文达信息工程学院", "淮北师范大学信息学院", "安徽工程大学", "安徽三联学院", "合肥师范学院", "皖西学院", "宿州学院", "池州学院", "安徽师范大学皖江学院", "安庆师范大学", "安徽大学", "阜阳师范学院", "巢湖学院", "铜陵学院", "安徽师范大学", "淮北师范大学", "安徽建筑大学城市建设学院", "安徽信息工程学院", "安徽新华学院", "黄山学院", "淮南师范学院"]},
                { title: '北京艺术生招生院校（本科）', schoolName: ["北京工商大学嘉华学院", "北京农学院", "北京建筑大学", "中国地质大学(北京)", "北京化工大学", "北京邮电大学世纪学院", "北京语言大学", "中央财经大学", "北京交通大学", "北京理工大学", "北京工商大学", "北京科技大学", "中华女子学院", "北京工业大学", "北京林业大学", "北方工业大学", "北京吉利学院", "北京航空航天大学", "北京邮电大学", "首都体育学院", "北京体育大学", "北京城市学院", "中国劳动关系学院", "北京工业大学耿丹学院", "北京大学", "中国人民大学", "北京师范大学", "首都师范大学", "北京联合大学", "首都师范大学科德学院"] },
                { title: '福建艺术生招生院校（本科）', schoolName: ["福建工程学院", "福建农林大学东方学院", "福建农林大学金山学院", "泉州信息工程学院", "福建师范大学闽南科技学院", "厦门华厦学院", "厦门理工学院", "武夷学院", "闽南理工学院", "福州外语外贸学院", "福建农林大学", "福建江夏学院", "集美大学诚毅学院", "闽江学院", "泉州师范学院", "三明学院", "阳光学院", "福州大学至诚学院", "厦门工学院", "厦门大学嘉庚学院", "福州大学", "宁德师范学院", "闽南师范大学", "龙岩学院", "华侨大学", "福建师范大学", "福建师范大学协和学院", "厦门大学", "集美大学", "莆田学院"]  },
                { title: '甘肃艺术生招生院校（本科）', schoolName: ["西北师范大学", "天水师范学院", "兰州财经大学", "兰州文理学院", "兰州大学", "陇东学院", "河西学院", "西北民族大学", "甘肃民族师范学院", "兰州城市学院", "兰州交通大学", "西北师范大学知行学院", "甘肃政法学院", "兰州商学院陇桥学院", "兰州理工大学", "兰州工业学院", "兰州财经大学长青学院", "兰州交通大学博文学院"] },
                { title: '广东艺术生招生院校（本科）', schoolName:  ["华南理工大学", "惠州学院", "暨南大学", "北京师范大学珠海分校", "广东东软学院", "广东理工学院", "韶关学院", "岭南师范学院", "华南农业大学", "五邑大学", "广州大学华软软件学院", "中山大学新华学院", "韩山师范学院", "深圳大学", "嘉应学院", "广东工业大学", "广州大学松田学院", "广东科技学院", "肇庆学院", "广东外语外贸大学", "广东技术师范学院", "北京师范大学-香港浸会大学联合国际学院", "广东财经大学华商学院", "仲恺农业工程学院", "广东石油化工学院", "广东海洋大学", "佛山科学技术学院", "华南农业大学珠江学院", "广东工业大学华立学院", "广州商学院", "广东技术师范学院天河学院", "广州大学", "广东海洋大学寸金学院", "广东财经大学", "广东培正学院", "北京理工大学珠海学院", "吉林大学珠海学院", "东莞理工学院", "广东第二师范学院", "广东白云学院", "汕头大学", "华南理工大学广州学院", "广州工商学院", "中山大学南方学院", "广州体育学院", "电子科技大学中山学院", "中山大学", "广州航海学院", "东莞理工学院城市学院", "华南师范大学"]  },
                { title: '广西艺术生招生院校（本科）', schoolName: ["桂林电子科技大学", "北海艺术设计学院", "桂林理工大学博文管理学院", "桂林理工大学", "广西科技大学鹿山学院", "桂林电子科技大学信息科技学院", "广西民族师范学院", "玉林师范学院", "梧州学院", "广西师范大学漓江学院", "北京航空航天大学北海学院", "广西民族大学相思湖学院", "钦州学院", "广西科技大学", "广西师范学院", "贺州学院", "广西师范学院师园学院", "广西大学", "广西师范大学", "百色学院", "桂林旅游学院", "广西外国语学院", "河池学院", "广西民族大学", "广西财经学院", "桂林航天工业学院", "南宁学院", "广西大学行健文理学院"] },
                { title: '贵州艺术生招生院校（本科）', schoolName: ["贵州师范大学", "凯里学院", "贵阳学院", "贵州大学", "遵义师范学院", "贵州民族大学", "贵州大学科技学院", "兴义民族师范学院", "贵州工程应用技术学院", "黔南民族师范学院", "六盘水师范学院", "贵州民族大学人文科技学院", "贵州师范学院", "铜仁学院", "安顺学院", "贵州财经大学", "贵州财经大学商务学院", "贵州师范大学求是学院", "贵州大学明德学院"] },
                { title: '海南艺术生招生院校（本科）', schoolName:  ["海南大学", "海口经济学院", "湖北文理学院", "海南热带海洋学院", "三亚学院", "海南师范大学"] },
                { title: '河北艺术生招生院校（本科）', schoolName: ["石家庄铁道大学四方学院", "河北建筑工程学院", "唐山学院", "华北科技学院", "河北东方学院", "华北电力大学科技学院", "华北理工大学轻工学院", "河北工业大学城市学院", "中国地质大学长城学院", "燕京理工学院", "河北工程大学", "石家庄铁道大学", "河北美术学院", "河北大学工商学院", "河北科技大学", "河北科技大学理工学院", "河北地质大学", "华北理工大学", "河北师范大学汇华学院", "河北农业大学现代科技学院", "北京交通大学海滨学院", "河北科技学院", "河北体育学院", "北华航天工业学院", "河北北方学院", "保定学院", "唐山师范学院", "邯郸学院", "沧州师范学院", "河北科技师范学院", "燕山大学", "河北农业大学", "河北民族师范学院", "邢台学院", "张家口学院", "河北大学", "河北师范大学", "衡水学院", "河北经贸大学", "河北传媒学院", "廊坊师范学院", "石家庄学院", "华北电力大学(保定)"] },
                { title: '河南艺术生招生院校（本科）', schoolName: ["商丘学院", "郑州成功财经学院", "郑州轻工业学院", "河南城建学院", "河南财经政法大学", "华北水利水电大学", "河南工程学院", "河南农业大学", "安阳工学院", "中原工学院信息商务学院", "河南工业大学", "郑州航空工业管理学院", "信阳学院", "河南科技学院新科学院", "河南科技学院", "郑州师范学院", "河南师范大学新联学院", "中原工学院", "河南大学民生学院", "郑州工商学院", "郑州升达经贸管理学院", "河南科技大学", "新乡学院", "郑州科技学院", "安阳师范学院", "南阳师范学院", "商丘师范学院", "平顶山学院", "南阳理工学院", "黄河科技学院", "洛阳理工学院", "郑州工业应用技术学院", "安阳学院", "郑州大学", "河南大学", "信阳师范学院", "河南理工大学", "河南师范大学", "周口师范学院", "许昌学院", "洛阳师范学院", "黄淮学院", "河南牧业经济学院", "商丘工学院"] },
                { title: '黑龙江艺术生招生院校（本科）', schoolName: ["齐齐哈尔工程学院", "哈尔滨广厦学院", "东北林业大学", "哈尔滨信息工程学院", "哈尔滨远东理工学院", "黑龙江工程学院昆仑旅游学院", "哈尔滨理工大学", "黑龙江东方学院", "黑龙江工程学院", "黑龙江财经学院", "哈尔滨工业大学", "哈尔滨商业大学", "哈尔滨音乐学院", "哈尔滨体育学院", "哈尔滨剑桥学院", "哈尔滨华德学院", "黑龙江外国语学院", "黑龙江工商学院", "哈尔滨石油学院", "佳木斯大学", "哈尔滨师范大学", "牡丹江师范学院", "大庆师范学院", "黑河学院", "黑龙江大学", "东北石油大学", "东北农业大学", "齐齐哈尔大学", "哈尔滨学院", "绥化学院", "黑龙江工业学院", "哈尔滨工程大学"] },
                { title: '湖北艺术生招生院校（本科）', schoolName: ["武汉科技大学", "武昌工学院", "湖北汽车工业学院", "华中农业大学", "武汉华夏理工学院", "武汉工程科技学院", "武汉商学院", "武汉生物工程学院", "武汉科技大学城市学院", "湖北工业大学工程技术学院", "武汉纺织大学外经贸学院", "武汉工商学院", "武汉工程大学邮电与信息工程学院", "湖北商贸学院", "武汉学院", "武汉轻工大学", "湖北工业大学", "湖北经济学院", "湖北经济学院法商学院", "湖北工程学院新技术学院", "武汉工程大学", "武汉理工大学", "武昌首义学院", "江汉大学文理学院", "中南财经政法大学", "湖北大学知行学院", "湖北文理学院理工学院", "华中科技大学", "湖北大学", "武汉东湖学院", "汉口学院", "长江大学文理学院", "武汉体育学院", "武汉体育学院体育科技学院", "武汉大学", "武汉纺织大学", "中南民族大学", "湖北科技学院", "三峡大学科技学院", "湖北民族学院科技学院", "湖北工程学院", "湖北理工学院", "江汉大学", "荆楚理工学院", "武昌理工学院", "中国地质大学(武汉)", "湖北师范大学", "湖北民族学院", "长江大学", "黄冈师范学院", "三峡大学", "文华学院", "湖北第二师范学院", "华中师范大学", "湖北汽车工业学院科技学院"] },
                { title: '湖南艺术生招生院校（本科）', schoolName: ["南华大学", "湖南农业大学东方科技学院", "长沙理工大学城南学院", "湖南应用技术学院", "南华大学船山学院", "湖南工程学院应用技术学院", "湘潭大学兴湘学院", "湖南商学院北津学院", "长沙理工大学", "湖南工程学院", "湖南科技大学潇湘学院", "中南林业科技大学涉外学院", "长沙师范学院", "湖南农业大学", "湖南大学", "湘潭大学", "湖南工业大学科技学院", "湖南商学院", "长沙学院", "湖南工业大学", "湖南第一师范学院", "湖南涉外经济学院", "湖南理工学院南湖学院", "吉首大学张家界学院", "湖南人文科技学院", "湖南文理学院芙蓉学院", "衡阳师范学院南岳学院", "湖南科技大学", "湖南理工学院", "湖南科技学院", "湖南师范大学", "衡阳师范学院", "怀化学院", "湖南城市学院", "湖南师范大学树达学院", "湖南文理学院", "吉首大学", "中南林业科技大学", "湘南学院", "邵阳学院", "湖南女子学院", "中南大学", "湖南信息学院"] },
                { title: '吉林艺术生招生院校（本科）', schoolName:  ["吉林大学", "北华大学", "吉林师范大学", "白城师范学院", "长春光华学院", "延边大学", "吉林工程技术师范学院", "吉林工商学院", "长春建筑学院", "吉林警察学院", "吉林建筑大学", "吉林农业大学", "吉林动画学院", "东北电力大学", "吉林师范大学博达学院", "长春大学旅游学院", "长春工业大学", "吉林建筑大学城建学院", "通化师范学院", "长春师范大学", "长春大学", "东北师范大学", "东北师范大学人文学院", "吉林体育学院", "长春理工大学", "长春工业大学人文信息学院", "长春科技学院", "长春理工大学光电信息学院", "长春工程学院"] },
                { title: '江苏艺术生招生院校（本科）', schoolName: ["南通大学", "江苏师范大学", "盐城师范学院", "扬州大学", "南京晓庄学院", "无锡太湖学院", "江苏师范大学科文学院", "南京航空航天大学", "南京师范大学", "淮阴师范学院", "南京师范大学泰州学院", "常州大学", "苏州科技大学", "常州工学院", "泰州学院", "南京特殊教育师范学院", "苏州科技大学天平学院", "江苏第二师范学院", "中国矿业大学", "常熟理工学院", "徐州工程学院", "中国传媒大学南广学院", "南京师范大学中北学院", "南京体育学院", "南京农业大学", "三江学院", "南京大学", "南京航空航天大学金城学院", "河海大学", "苏州大学文正学院", "东南大学", "南京信息工程大学", "南京财经大学", "南京工程学院", "江苏理工学院", "江苏大学京江学院", "南京邮电大学", "江苏大学", "金陵科技学院", "东南大学成贤学院", "南京大学金陵学院", "南通大学杏林学院", "南京林业大学", "南京理工大学", "淮海工学院", "南京工业大学", "盐城工学院", "南京工业大学浦江学院", "扬州大学广陵学院", "淮阴工学院", "苏州大学应用技术学院", "中国矿业大学徐海学院", "南京理工大学泰州科技学院", "南通理工学院", "河海大学文天学院", "宿迁学院", "南京信息工程大学滨江学院", "西交利物浦大学", "常州大学怀德学院"] },
                { title: '江西艺术生招生院校（本科）', schoolName: ["江西农业大学", "江西科技师范大学", "东华理工大学", "江西师范大学", "华东交通大学", "南昌航空大学", "江西中医药大学", "上饶师范学院", "赣南师范大学", "江西财经大学", "江西科技学院", "南昌工程学院", "新余学院", "江西应用科技学院", "南昌大学科学技术学院", "江西科技师范大学理工学院", "南昌大学", "宜春学院", "井冈山大学", "萍乡学院", "九江学院", "南昌理工学院", "江西师范大学科学技术学院", "南昌师范学院", "南昌航空大学科技学院", "江西服装学院", "景德镇陶瓷大学", "景德镇陶瓷大学科技艺术学院", "江西理工大学", "江西工程学院", "南昌工学院", "华东交通大学理工学院", "江西理工大学应用科学学院", "江西农业大学南昌商学院", "景德镇学院", "南昌大学共青学院", "江西财经大学现代经济管理学院"] },
                { title: '辽宁艺术生招生院校（本科）', schoolName: ["辽宁科技大学", "沈阳师范大学", "鞍山师范学院", "沈阳大学", "东北大学", "辽宁师范大学", "渤海大学", "沈阳音乐学院", "大连大学", "辽宁科技学院", "大连艺术学院", "辽东学院", "大连外国语大学", "沈阳体育学院", "辽宁大学", "大连工业大学艺术与信息工程学院", "辽宁财贸学院", "沈阳航空航天大学", "大连工业大学", "沈阳工学院", "大连财经学院", "辽宁传媒学院", "沈阳城市学院", "辽宁石油化工大学", "沈阳建筑大学", "辽宁理工学院", "大连东软信息学院", "沈阳理工大学", "辽宁工程技术大学", "大连交通大学", "大连海洋大学", "大连民族大学", "大连科技学院", "辽宁何氏医学院", "大连医科大学", "大连理工大学", "沈阳化工大学", "辽宁工业大学", "辽宁对外经贸学院", "沈阳城市建设学院", "辽宁师范大学海华学院", "沈阳工业大学", "大连医科大学中山学院", "大连理工大学城市学院"] },
                { title: '内蒙古艺术生招生院校（本科）', schoolName: ["内蒙古师范大学", "赤峰学院", "集宁师范学院", "内蒙古艺术学院", "内蒙古科技大学", "内蒙古民族大学", "呼伦贝尔学院", "鄂尔多斯应用技术学院", "河套学院", "呼和浩特民族学院", "内蒙古大学创业学院", "内蒙古师范大学鸿德学院", "内蒙古农业大学", "内蒙古工业大学"] },
                { title: '宁夏艺术生招生院校（本科）', schoolName: ["北方民族大学", "宁夏大学", "宁夏师范学院", "宁夏大学新华学院", "宁夏理工学院", "中国矿业大学银川学院"] },
                { title: '山东艺术生招生院校（本科）', schoolName: ["中国海洋大学", "青岛理工大学", "山东理工大学", "曲阜师范大学", "德州学院", "泰山学院", "烟台大学", "烟台南山学院", "青岛科技大学", "齐鲁工业大学", "山东师范大学", "聊城大学", "鲁东大学", "菏泽学院", "青岛大学", "潍坊学院", "聊城大学东昌学院", "山东科技大学", "济南大学", "山东农业大学", "枣庄学院", "中国石油大学胜利学院", "齐鲁师范学院", "山东大学威海分校", "山东大学", "中国石油大学(华东)", "滨州学院", "临沂大学", "济宁学院", "山东财经大学", "山东女子学院", "山东体育学院", "青岛恒星科技学院", "山东青年政治学院", "山东师范大学历山学院", "济南大学泉城学院", "北京电影学院现代创意媒体学院", "青岛农业大学", "青岛理工大学琴岛学院", "青岛滨海学院", "潍坊科技学院", "青岛黄海学院", "齐鲁理工学院", "山东建筑大学", "青岛农业大学海都学院", "山东英才学院", "烟台大学文经学院", "山东财经大学东方学院", "山东交通学院", "山东农业工程学院"] },
                { title: '山西艺术生招生院校（本科）', schoolName: ["山西大学", "山西师范大学", "晋中学院", "山西大学商务学院", "中北大学", "太原师范学院", "运城学院", "山西应用科技学院", "山西工商学院", "长治医学院", "吕梁学院", "中北大学信息商务学院", "山西大同大学", "长治学院", "忻州师范学院", "山西师范大学现代文理学院", "山西传媒学院", "太原理工大学", "山西农业大学信息学院", "太原理工大学现代科技学院", "太原科技大学", "山西农业大学", "山西财经大学", "太原科技大学华科学院", "太原工业学院"] },
                { title: '陕西艺术生招生院校（本科）', schoolName: ["陕西师范大学", "西安文理学院", "渭南师范学院", "西安外事学院", "宝鸡文理学院", "商洛学院", "西安石油大学", "延安大学", "咸阳师范学院", "西安体育学院", "榆林学院", "安康学院", "陕西学前师范学院", "西安建筑科技大学华清学院", "陕西理工大学", "西北大学现代学院", "西安工程大学", "西安外国语大学", "西安工业大学", "长安大学", "西安培华学院", "西安建筑科技大学", "西北政法大学", "西安财经学院", "西安翻译学院", "西北大学", "陕西科技大学", "西安邮电大学", "西安电子科技大学", "西北工业大学明德学院", "西安科技大学高新学院", "西藏民族大学", "西安交通大学城市学院", "西安理工大学", "西安科技大学", "西京学院", "陕西国际商贸学院", "西安交通大学", "西安欧亚学院", "陕西服装工程学院", "延安大学西安创新学院", "西安思源学院", "西北农林科技大学", "西安财经学院行知学院", "西安理工大学高科学院", "西北工业大学"] },
                { title: '四川艺术生招生院校（本科）', schoolName: ["西南交通大学", "西南科技大学", "绵阳师范学院", "宜宾学院", "乐山师范学院", "西南民族大学", "四川文化艺术学院", "成都理工大学", "四川理工学院", "四川师范大学", "西华师范大学", "内江师范学院", "成都学院", "四川传媒学院", "西华大学", "四川文理学院", "成都师范学院", "四川大学", "西昌学院", "阿坝师范学院", "四川民族学院", "四川工商学院", "成都体育学院", "四川大学锦江学院", "四川电影电视学院", "西南石油大学", "成都文理学院", "四川大学锦城学院", "成都东软学院", "电子科技大学成都学院", "四川农业大学", "攀枝花学院", "成都理工大学工程技术学院", "成都信息工程大学银杏酒店管理学院", "西南财经大学天府学院", "成都信息工程大学", "四川旅游学院", "西南科技大学城市学院"] },
                { title: '新疆艺术生招生院校（本科）', schoolName: ["西藏大学", "新疆师范大学", "石河子大学", "伊犁师范学院", "昌吉学院", "喀什大学", "新疆大学", "塔里木大学"]  },
                { title: '云南艺术生招生院校（本科）', schoolName: ["大理大学", "红河学院", "云南民族大学", "楚雄师范学院", "云南艺术学院文华学院", "云南师范大学", "云南大学滇池学院", "昭通学院", "保山学院", "玉溪师范学院", "昆明学院", "云南师范大学商学院", "云南大学", "曲靖师范学院", "文山学院", "云南师范大学文理学院", "昆明理工大学", "西南林业大学", "云南大学旅游文化学院", "昆明医科大学海源学院", "云南工商学院", "云南财经大学"] },
                { title: '浙江艺术生招生院校（本科）', schoolName: ["浙江师范大学", "绍兴文理学院", "杭州师范大学", "温州大学", "杭州师范大学钱江学院", "湖州师范学院", "台州学院", "丽水学院", "衢州学院", "温州大学瓯江学院", "宁波大学", "湖州师范学院求真学院", "浙江外国语学院", "浙江工业大学", "浙江万里学院", "浙江科技学院", "宁波大红鹰学院", "浙江工业大学之江学院", "浙江理工大学科技与艺术学院", "浙江工商大学", "浙江树人学院", "宁波大学科学技术学院", "浙江大学", "浙江农林大学", "浙江财经大学", "中国计量大学", "浙江农林大学暨阳学院", "绍兴文理学院元培学院", "浙江师范大学行知学院", "温州商学院", "温州肯恩大学", "浙江工商大学杭州商学院", "嘉兴学院", "浙江大学城市学院", "浙江财经大学东方学院", "浙江大学宁波理工学院", "杭州电子科技大学信息工程学院", "杭州电子科技大学", "浙江越秀外国语学院"] },
                { title: '重庆艺术生招生院校（本科）', schoolName: ["西南大学", "重庆师范大学", "重庆师范大学涉外商贸学院", "重庆大学", "长江师范学院", "重庆人文科技学院", "四川外国语大学重庆南方翻译学院", "重庆文理学院", "重庆邮电大学", "四川外国语大学", "重庆三峡学院", "重庆工商大学", "重庆工程学院", "重庆邮电大学移通学院", "重庆交通大学", "重庆科技学院", "重庆第二师范学院", "重庆大学城市科技学院", "重庆理工大学"] },
                { title: '上海艺术生招生院校（本科）', schoolName: ["上海师范大学", "同济大学", "华东师范大学", "上海外国语大学贤达经济人文学院", "上海大学", "上海体育学院", "上海政法学院", "上海理工大学", "上海应用技术大学", "上海工程技术大学", "上海杉达学院", "上海交通大学", "上海第二工业大学", "上海师范大学天华学院", "华东理工大学", "上海海事大学", "上海商学院", "上海建桥学院", "上海电机学院"] },
                { title: '天津艺术生招生院校（本科）', schoolName: ["天津师范大学", "天津体育学院运动与文化艺术学院", "天津师范大学津沽学院", "北京科技大学天津学院", "天津财经大学珠江学院", "天津体育学院", "天津科技大学", "天津大学", "天津职业技术师范大学", "天津商业大学", "天津天狮学院", "天津商业大学宝德学院", "天津大学仁爱学院", "天津理工大学", "天津外国语大学", "南开大学", "天津财经大学", "河北工业大学", "南开大学滨海学院", "天津农学院", "天津城建大学"] }
            ]
        }
    },
    methods: {
        goUniversity1(id,index) {
            if(index == 11||index==16||index==20) {
                return;
            }
            var id = id;
            let {href}=this.$router.resolve({
                path: '/explore/yuanxiaoxiangqing',
                name: '院校详情',
                query: {
                    id: id,
                }
            })
            var sUserAgent = navigator.userAgent.toLowerCase();
            var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
            var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
            var bIsMidp = sUserAgent.match(/midp/i) == "midp";
            var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
            var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
            var bIsAndroid = sUserAgent.match(/android/i) == "android";
            var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
            var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
            if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
                this.$router.push('/yuanxiaoxiangqing_mobile?id='+id)
            } else {
                this.$router.push('/explore/yuanxiaoxiangqing?id='+id)
            } 



            // window.open(href, '_blank');
            //  this.$router.push('/explore/yuanxiaoxiangqing?id='+id)
        },
        goUniversity(id) {
            var id = id;
            let {href}=this.$router.resolve({
                path: '/explore/yuanxiaoxiangqing',
                name: '院校详情',
                query: {
                    id: id,
                }
            })
            var sUserAgent = navigator.userAgent.toLowerCase();
            var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
            var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
            var bIsMidp = sUserAgent.match(/midp/i) == "midp";
            var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
            var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
            var bIsAndroid = sUserAgent.match(/android/i) == "android";
            var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
            var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
            if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
                this.$router.push('/yuanxiaoxiangqing_mobile?id='+id)
            } else {
                this.$router.push('/explore/yuanxiaoxiangqing?id='+id)
            } 



            // window.open(href, '_blank');
            //  this.$router.push('/explore/yuanxiaoxiangqing?id='+id)
        },
        // 获取自招院校，省内是1，全部是2
        getZizhuzhaoshengList() {
            var _this = this;
            var token = window.sessionStorage.getItem('ymtxToken')||window.localStorage.getItem('localtoken');
            this.$ajax
                .post(this.G_uri + '/target/getGroupZizhuzhaoshengList', {
                    token: token
                },{
                    headers:{
                        token: token
                    }
                })
                // 监听数据返回
                .then(function(res) {
                    _this.universityData = res.data.data[2];
                    _this.universityShengnei = res.data.data[1];
                })
                .catch(function(error) {
                    console.log(error)
                })
        },
    },
    created() {
        this.getZizhuzhaoshengList();
    }
}
</script>
<style type="text/css" lang='less' scoped>
.artEnrollment {
    box-sizing: border-box;
    width: 970px;
    background-color: #fff;
    padding: 20px;
    .banner {
        width: 100%;
    }
    .main {
        padding-top: 40px;
        table {
            tr {
                td {
                    border: 1px solid #dedede;
                    &:first-child {
                        padding: 20px;
                        width: 25%;
                        text-align: center;
                    }
                    &:last-child {
                        padding: 20px;
                    }
                }
            }
        }
    }
    .main_title {
        line-height: 40px;
        text-align: left;
        font-size: 16px;
        font-weight: 600;
        color: #333;
        margin-bottom: 20px;
        padding-left: 40px;
        background: url(/imgs/wayToStudy/common/icon_title.png) no-repeat 0px center;
    }
    .main_box {
        p {
            line-height: 30px;
            font-size: 14px;
            color: #666;
            margin-bottom: 10px;
        }
    }   
    // 报考流程
    .application_process {
        ul.lis_box {
            display: flex; 
            justify-content: space-between;
            li {
                width: 160px;
                text-align: center;
                box-shadow: 0px 0px 10px 0 rgba(4,0,0,0.27);
                p {
                    &:first-child {
                        line-height: 30px;
                        background-color: #8fcfe9;
                        color: #fff;
                    }
                    &:last-child {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        height: 70px;
                        line-height: 24px;
                        color: #333;
                        font-size: 14px;
                    }
                }
            }
        }
    }
    .remind {
        .main_box {
            p {
                span {
                    display: inline-block;
                    width: 24px;
                    height: 24px;
                    line-height: 24px;
                    text-align: center;
                    border-radius: 50%;
                    background-color: #2c8ffc;
                    color: #fff;
                    vertical-align: middle;
                    margin-right: 6px;
                    font-size: 12px;
                }
            }
        }

    }
    .universities {
        .main_title {
            span {
                font-size: 14px;
                color: red;
            }
        }
        .school_title {
            background: #60badf;
            color: #fff;
            line-height: 50px;
            text-align: center;
            border: 1px solid #60badf;
        }
        .province_school {
            text-align: center;
            line-height: 50px;
            font-size: 16px;
        }
        ul {
            overflow: hidden;
            width: 933px;
            li {
                font-size: 14px;
                box-sizing: border-box;
                float: left;
                width: 25%;
                border: 1px solid #eaeaea;
                margin-left: -1px;
                margin-top: -1px;
                min-height: 42px;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                line-height: 20px;
                text-align: center;
                &:nth-child(4n+1) {
                    margin-left: 0px;
                }
                &:nth-child(-n + 4) {
                    margin-top: 0px;
                }
                // &:nth-child(8n-1),&:nth-child(8n-2),&:nth-child(8n-3),&:nth-child(8n) {
                //     background-color: #e6f8ff;
                // }
            }
        }
    }
}
@media only screen and (max-width:760px) {
    .artEnrollment{
        width: auto;
    }
    .artEnrollment .universities ul{
        width: auto;
    }
}
</style>